<template>
  <div id="app">
    <div class="flex-box win-tool" v-if="nw">
      <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
        <div class="tool-item" @click="refreshHandle">
          <i class="el-icon-refresh-right"></i>
        </div>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="最小化"
        placement="bottom"
      >
        <div class="tool-item" @click="minimize()">
          <i class="el-icon-minus"></i>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="关闭" placement="bottom">
        <div class="tool-item" @click="close">
          <i class="el-icon-close"></i>
        </div>
      </el-tooltip>
    </div>
    <router-view />
  </div>
</template>

<script>
import socket from "@/utils/socket";
import store from "@/store";
import { EventBus } from "@/utils/eventBus";
import { downloadUpdate } from "@/utils/checkUpdate";
import { getVersion } from "@/api/versions";
import uploadPop from "@/utils/uploadPop";
export default {
  name: "App",
  data() {
    return {
      nw: window.nw,
    };
  },
  mounted() {
    this.freshuserinfo();
  },
  created() {
    const type = localStorage.getItem("oldTopic") || "2";
    localStorage.setItem("oldTopic", type);
    if (window.nw) {
      this.checkVer();
    }
    // 创建连接
    this.socket = new socket(process.env["VUE_APP_BASE_WS"], {
      onOpen: () => {
        console.log("连接成功");
      },
      onClose: () => {
        console.log("连接关闭");
      },
      onError: (err) => {
        console.error("连接出错", err);
      },
    });
    // 绑定自定义消息事件
    this.socket.on("init", (message) => {
      store.commit("user/SET_CLIENT_ID", message.client_id);
      let timer = setTimeout(() => {
        clearTimeout(timer);
        EventBus.$emit("wsInit");
      }, 500);
      const token = this.$utils.getToken();
      if (token) {
        store.dispatch("paper/initSetting");
        store.dispatch("user/initPermission");
        this.socket.send({
          type: "login",
          platform: 7,
          token: token,
        });
      }
    });
    // 建立连接
    this.socket.connect();
    EventBus.$on("wsSendMsg", (msg) => {
      console.log("wsSendMsg", msg);
      if (this.socket && this.socket.send) {
        this.socket.send(msg);
      }
    });
    try {
      // 初始化全屏
      if (nw) {
        const win = nw.Window.get();
        win.maximize();
      }
    } catch (e) {}
  },
  beforeDestroy() {
    // 关闭连接
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    sendMessage() {
      this.socket.send({
        event: "chat",
        message: "Hello Server",
      });
    },
    checkVer() {
      getVersion().then((res) => {
        if (res.code != 200) return;
        const { update_log, is_force, is_silent, url, version, need_update } =
          res.data;
        const app_ver = window.nw ? nw.App.manifest.version : "";

        if (!need_update) return;

        if (app_ver == version && version) return;

        if (is_force != 1) return;
        downloadUpdate(url, {
          content: update_log,
          closable: is_force != 1,
          is_silent: is_silent == 1,
        });
      });
    },
    refreshHandle() {
      nw.Window.get().reload();
    },
    minimize() {
      nw.Window.get().minimize();
    },
    close() {
      nw.Window.get().close();
    },
    freshuserinfo() {
      const userinfo = localStorage.getItem("userInfo");
      if (userinfo) {
        this.$store.commit("user/SET_USER_INFO", JSON.parse(userinfo));
      }
    },
  },
};
</script>

<style lang="scss">
@import "./common/css/common.scss";

body {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, 微软雅黑, Arial, sans-serif;
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: bold;
}

#app {
}
.win-tool {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 5px;
  right: 10px;
  z-index: 1999999;

  .tool-item {
    background: #efefef;
    width: 30px;
    height: 30px;
    padding-top: 2px;
    color: #333;
    font-size: 18px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    font-weight: bold;
    align-items: center;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      background: #ddd;
    }
  }
}
.allow-copy {
  -webkit-user-select: text; /* Chrome / Safari */
  -moz-user-select: text; /* Firefox */
  -ms-user-select: text; /* 旧版 IE / Edge */
  user-select: text; /* 标准 */
}

.allow-copy ::selection {
  background: #5082f7; /* 选中背景色 */
  color: #fff; /* 选中文字颜色 */
}

/* 兼容 Firefox */
.allow-copy ::-moz-selection {
  background: #5082f7;
  color: #fff;
}
</style>
